import { useEffect, useState } from 'react';

export const checkIfImageExists = async (imageUrl: string, good: () => void) => {
  const img = new Image();
  img.onload = good;
  img.src = imageUrl;
};

export const useIsImageExists = (imageUrl?: string) => {
  const [ifImageExist, setIfImageExists] = useState(false);

  useEffect(() => {
    async function checkImage() {
      if (imageUrl) {
        void checkIfImageExists(imageUrl, function () {
          setIfImageExists(true);
        });
      }
    }
    if (imageUrl) {
      void checkImage();
    }
  }, [imageUrl]);

  return ifImageExist;
};
